import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent({ width = 110, height = 110, ...props }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 110 110"
      fill="none"
      {...props}
    >
      <Path
        d="M0 55C0 24.673 24.673 0 55 0s55 24.673 55 55-24.673 55-55 55S0 85.327 0 55z"
        fill="#000"
        fillOpacity={props.bgOpacity || 0.05}
      />
      <Path
        d="M.5 55C.5 24.949 24.949.5 55 .5s54.5 24.449 54.5 54.5-24.449 54.5-54.5 54.5S.5 85.051.5 55z"
        stroke="#000"
        strokeOpacity={0.05}
      />
      <Path
        opacity={props.opacity || 0.7}
        d="M77.559 35.45c0 12.438-10.12 22.558-22.559 22.558-12.439 0-22.559-10.12-22.559-22.559 0-12.439 10.12-22.558 22.559-22.558 12.439 0 22.559 10.12 22.559 22.558zM91.232 72.068a22.578 22.578 0 00-16.897-7.615H35.663a22.578 22.578 0 00-16.897 7.615l-1.528 1.726 1.14 2.004C25.858 88.942 39.891 97.108 55 97.108s29.14-8.166 36.621-21.312l1.14-2.003-1.528-1.726z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
